/**
 * Bảng `ChallengeConfiguration` — cấu hình dùng chung cho tính năng thử thách (FR-08).
 *
 * API #1 `GET  /admin/v1/stamp-collection/challenge-configuration`
 * API #2 `PUT  /admin/v1/stamp-collection/challenge-configuration`
 *
 * ✅ API duy nhất khớp 100% cả request lẫn response với DTO này.
 *
 * Config có **version**: BE xác nhận API #2 *"create a new immutable current snapshot"*,
 * bản cũ vẫn được các Challenge đã tạo tham chiếu qua `Challenge.challengeConfigurationId`.
 * → Màn Settings thao tác trên bản hiện hành; màn Edit Challenge phải đọc giới hạn
 *   từ snapshot của challenge đó, không dùng bản hiện hành.
 *
 * ⚠️ BE-MISSING B3: API #10 (Challenge Detail) chỉ trả `challengeConfigurationId`,
 * **không embed** 3 giới hạn (`milestoneLimit`, `rewardTierLimit`, `rewardOptionLimit`)
 * và cũng **không có** API đọc snapshot theo id. Màn Edit Challenge đang buộc phải dùng
 * bản hiện hành ⇒ validate SAI với challenge tạo trước khi config đổi.
 * → Cần BE embed object `challengeConfiguration` vào API #10, hoặc mở
 *   `GET /challenge-configuration/:id`.
 */
export class ChallengeConfigDto {
  public id?: string
  /** Số quà còn lại được coi là sắp hết quà (FR-10-BR-01). */
  public rewardLowStockThreshold?: number
  /** Số ngày trước Challenge end time để gửi thông báo (FR-10-BR-04). */
  public challengeEndingSoonDays?: number
  /** Số ngày trước Redemption end time để gửi thông báo (FR-10-BR-05). */
  public redemptionEndingSoonDays?: number
  /** Số Milestone tối đa trong một Challenge (FR-03-BR-01). */
  public milestoneLimit?: number
  /** Số Reward Tier tối đa trong một Challenge (FR-04-BR-01). */
  public rewardTierLimit?: number
  /** Số Reward Option tối đa trong một Reward Tier (FR-04-BR-01). */
  public rewardOptionLimit?: number

  public static create(data?: Partial<ChallengeConfigDto>): ChallengeConfigDto {
    const instance = new ChallengeConfigDto()
    if (data) {
      Object.assign(instance, data)
    }
    return instance
  }
}
